<template>
  <div>
    <v-text-field
        v-bind="$attrs"
        class="mt-3 mb-n3"
        dense
        outlined
        :background-color="is_comparable()"
        v-model="vmodel"
    >
    </v-text-field>
  </div>
</template>

<script>

export default {
  name: 'BaseComparableTextField',
  props: ['comparable', 'vmodel'],

  methods: {
    is_comparable() {
      if (this.comparable)
        return 'green accent-1'
      else
        return 'red accent-1'
    }
  },
  created() {
    console.log("$attrs")
    console.log(this.$attrs)
  }
}
</script>

<style scoped lang="scss">
</style>
